import { render } from "./vc4a-multiselect.vue?vue&type=template&id=81b8b432"
import script from "./vc4a-multiselect.vue?vue&type=script&lang=js"
export * from "./vc4a-multiselect.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"

import exportComponent from "/Users/hendrik/Projects/vc4a.local/wp-content/themes/vc4africa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__